import { useColumns } from "./useColumns";

const useTableColumns = (tableId: string) => {
    // Hook implementation
    const { data } = useColumns();

    return data?.filter(column => column.sys_table_id === tableId) || [];
};

export default useTableColumns;